
import {Outlet} from "react-router-dom";
import Sidebar from "../Sidebar";

const Layout = () => {
  return (
    <>
      <Sidebar />
      <Outlet />
    </>
  );
};

export default Layout;